import { render, staticRenderFns } from "./LayoutHeader2.vue?vue&type=template&id=319e9e39&scoped=true"
import script from "./LayoutHeader2.vue?vue&type=script&lang=js"
export * from "./LayoutHeader2.vue?vue&type=script&lang=js"
import style0 from "./LayoutHeader2.vue?vue&type=style&index=0&id=319e9e39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319e9e39",
  null
  
)

export default component.exports